import { render, staticRenderFns } from "./ModattaBrandSnapTabs.vue?vue&type=template&id=4f6091e5&scoped=true"
import script from "./ModattaBrandSnapTabs.vue?vue&type=script&lang=js"
export * from "./ModattaBrandSnapTabs.vue?vue&type=script&lang=js"
import style0 from "./ModattaBrandSnapTabs.vue?vue&type=style&index=0&id=4f6091e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6091e5",
  null
  
)

export default component.exports